import { Typography as MaterialTypography, TypographyProps } from '@material-ui/core';
import React from 'react';

type TProps = TypographyProps &
  Pick<
    React.CSSProperties,
    'fontWeight' | 'fontStyle' | 'fontSize' | 'textDecoration' | 'textTransform'
  >;

export const Typography: React.FC<TProps> = ({
  fontStyle,
  fontWeight,
  style,
  textDecoration,
  textTransform,
  fontSize,
  ...materialProps
}) => (
  <MaterialTypography
    style={{
      textTransform,
      fontWeight,
      fontStyle,
      textDecoration,
      fontSize,
      ...style,
    }}
    {...materialProps}
  />
);
